import { Col, Form, Row, Input, Button, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";

import "../../styles/components.scss";
import { Header } from "../../components/Header";
import { CollapseComponent } from "../../components/Collapse";
import { FormattedMessage } from "react-intl";
import axios from "axios";
import cookie from "react-cookies";
import { useLocation, useNavigate } from "react-router-dom";
import { getInputs } from "../../utils/APIs";
import ScreenLoader from "../../components/ScreenLoader";

const { Option } = Select;
//increaseStartLow
const formPricingData = {
  bracesInput: 17.9,
  cheekRetractors: 5,
  nbPatientIncl: 0,
  perPatient: 11.9,
  priceMonthDoctorSmileMate: 249,
  priceMonthDoctorMileAndVision: 299,
  priceMonthDoctorVisionSoftware: 149,
  scanboxCost: 41,
  licenseFee: 0,

  tier1Braces: 17.9,
  tier1LicenseFee: 0,
  tier1PerPatient: 11.9,
  tier2Braces: 17.9,
  tier2LicenseFee: 0,
  tier2PerPatient: 11.9,
  tier3Braces: 16.1,
  tier3LicenseFee: 0,
  tier3PerPatient: 10.7,
  tier4Braces: 14.3,
  tier4LicenseFee: 0,
  tier4PerPatient: 9.5,
  tier5Braces: 14.3,
  tier5LicenseFee: 0,
  tier5PerPatient: 9.5,
};

const dataClaimVision = {
  increaseInConversionContactLow: 0,
  increaseInConversionContactHigh: 0,

  increaseInConversionRateLow: 10.0,
  increaseInConversionRateHigh: 15.0,

  increaseInStartHigh: 0,
  increaseInStartLow: 0,
  reductionChaireTimeHigh: 0,
  reductionChaireTimeLow: 0,
  reductionDoctorHigh: 0,
  reductionDoctorLow: 0,
  increaseInStartLow: 12.5,
  increaseInStartHigh: 18.8,
};

const dataClaimMonitoringAlligners = {
  reductionInNumberOfCheckUpAverageLow: -58.314,
  reductionInNumberOfCheckUpAverageHigh: -70.0,

  impliedReductionAverageLow: -38.0,
  impliedReductionAverageHigh: -70.0,

  reductionInNumberOfEmergencyAverageLow: -46.786,
  reductionInNumberOfEmergencyAverageHigh: -50,

  initialAppointments: 2,
  initialAppointmentsDoctor: 15,
  initialAppointmentsDentalAssistant: 15,
  initialAppointmentsTreatment: 15,
  initialAppointmentsFrontDesk: 3,

  checkUpAdjustmentStaffdentalAssistantLow: 0,
  checkUpAdjustmentStaffdentalAssistantHigh: 0,

  checkUpAdjustmentStafftreatmentCoordinatorLow: 0,
  checkUpAdjustmentStafftreatmentCoordinatorHigh: 0,

  checkUpAdjustmentStafffrontDeskLow: 0,
  checkUpAdjustmentStafffrontDeskhigh: 0,

  checkUpAdjustmentStaffDoctorLow: 0,
  checkUpAdjustmentStaffDoctorHigh: 0,

  refinementAppointmentsNumber: 2,
  refinementsAppointmentsDoctor: 15,
  refinementsAppointmentsDentalAssistant: 10,
  refinementsAppointmentsTreatment: 0,
  refinementsAppointmentsFrontDesk: 3,

  reductionInPreparedentalAssistantLow: -50,
  reductionInPreparedentalAssistantHigh: -75,

  reductionInPreparetreatmentCoordinatorLow: -50,
  reductionInPreparetreatmentCoordinatorHigh: -75,

  reductionInPreparefrontDeskLow: -50,
  reductionInPreparefrontDeskhigh: -75,

  finalAppointments: 1,
  finalAppointmentsDoctor: 15,
  finalAppointmentsDentalAssistant: 15,
  finalAppointmentsTreatment: 15,
  finalAppointmentsFrontDesk: 3,

  treatmentDurationAdults: 12.0,
  treatmentDurationTeen: 15.0,
};

const dataClaimMonitoringBraces = {
  monitoringBracesadultsOrAverageLow: -33,
  monitoringBracesadultsOrAverageHigh: -40.0,

  monitoringBracesteensLow: -33.176,
  monitoringBracesteensHigh: -40.0,

  monitoringreductionInNumberOfEmergencyadultsOrAverageLow: -40.228,
  monitoringreductionInNumberOfEmergencyadultsOrAverageHigh: -50,

  initialAppointments: 3,
  initialAppointmentsDoctor: 20,
  initialAppointmentsFront: 3,
  initialAppointmentsTreatment: 15,
  initialAppointmentsDentalAssistant: 20,
  reductionInCheckUpTreatmentLow: "0",
  reductionInCheckUpTreatmentHigh: "0",
  reductionInCheckUpFrontLow: "0",
  reductionInCheckUpFrontHigh: "0",
  reductionInCheckUpDentalLow: "0",
  reductionInCheckUpDentalHigh: "0",
  reductionInCheckUpDocLow: "0",
  reductionInCheckUpDocHigh: "0",

  ofWFrontLow: -30,
  ofWFrontHigh: -50,

  ofWTreatmentLow: 0,
  ofWTreatmentHigh: 0,

  ofWdentalAssistantLow: -30,
  ofWdentalAssistantHigh: -50,

  manageDMDoctorLow: 4,

  manageDMFrontLow: 0,

  manageTreatmentLow: 8,
  manageTreatmentHigh: 0,

  manageDentalLow: 0,
  manageDentalHigh: 0,

  removalRetainer: 3,
  removalRetainerDoctor: 15,
  removalRetainerFront: 5,
  removalRetainerTreatment: 15,
  removalRetainerDental: 25,

  treatmentDurationTeen: 12,
  treatmentDurationAdults: 12,

  increaseLow: 5,
  increaseHigh: 10,
};

const dataManagingDmNotification = {
  doctorTimeSpent: 2,
  doctorPercentageScan: 10,
  dentalAssistant: 0,
  treatmentCoordinatorTimeSpent: 3,
  treatmentCoordinatorPercentageScan: 40,
  frontDesk: 0,
};

const dataInputPractice = {
  alignersdrTime: 5,
  alignersstaffCheckup: 27,
  alignersstaffPrepare: 10,

  bracesdrTime: 5,
  bracesstaffCheckup: 22,
  bracesstaffPrepare: 10,
};

const Inputs = () => {
  const [listInputs, setInputs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [formSelect] = Form.useForm();
  const [formClaim] = Form.useForm();
  const [formVision] = Form.useForm();
  const [formMonitoring] = Form.useForm();
  const [formclaimBraces] = Form.useForm();
  const [formDmNotifications] = Form.useForm();
  const [formInput] = Form.useForm();
  const navigate = useNavigate();

  const location = useLocation();

  const [name, setName] = useState(location.state.name);
  const [symbol, setSymbol] = useState("$");
  const [selectedCurrency, setSelectedCurrency] = useState({});
  useEffect(() => {
    form.setFieldsValue(formPricingData);
    formVision.setFieldsValue(dataClaimVision);
    formMonitoring.setFieldsValue(dataClaimMonitoringAlligners);
    formclaimBraces.setFieldsValue(dataClaimMonitoringBraces);
    formDmNotifications.setFieldsValue(dataManagingDmNotification);
    formInput.setFieldsValue(dataInputPractice);

    getInputs(location.state.id).then((res) => {
      setInputs(res);
      toUpdateSelectedCurrency(res[0]);
      formSelect.setFieldsValue({
        currency: res[0].name,
      });
      setLoading(false);
    });
  }, []);

  const toUpdateSelectedCurrency = (currency) => {
    form.setFieldsValue(currency.inputs.pricing);
    formMonitoring.setFieldsValue(currency.inputs.monitoring);
    formclaimBraces.setFieldsValue(currency.inputs.claimBraces);
    formDmNotifications.setFieldsValue(currency.inputs.dmNotifs);
    formInput.setFieldsValue(currency.inputs.inputPractice);
    setSymbol(currency.symbol);
    setSelectedCurrency(currency);
  };

  const validateForms = () => {
    var json = {
      pricing: form.getFieldsValue(),
      vision: formVision.getFieldsValue(),
      monitoring: formMonitoring.getFieldsValue(),
      claimBraces: formclaimBraces.getFieldsValue(),
      dmNotifs: formDmNotifications.getFieldsValue(),
      inputPractice: formInput.getFieldsValue(),
    };

    axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "api/inputs/update",
        {
          inputs: json,
          id: selectedCurrency.id,
          name: name,
          inputsId: location.state.id,
        },
        {
          headers: {
            Authorization: "Bearer " + cookie.load("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then(() => {
        navigate("/admin");
      });
  };
  const pricing = (
    <>
      <Form form={form} name="pricing">
        {/* SmileMate*/}
        <Row>
          <Col span={16}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              className="roi--header-content"
              label={<FormattedMessage id="hardware" />}
            ></Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={20}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              style={{ marginLeft: "2vh" }}
              className="roi--label-section"
              label={<FormattedMessage id="scanboxCost" />}
            >
              <hr className="roi--hr" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              className="roi--label-section"
              defaultValue={"41"}
              name="scanboxCost"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                defaultValue="41"
                prefix={symbol}
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={20}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              className="roi--header-content"
              label={<FormattedMessage id="smileMateAndVision" />}
            >
              <hr className="roi--hr" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              className="roi--label-section"
              name="priceMonthDoctorSmileMate"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                defaultValue="249"
                prefix={symbol}
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={16}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              className="roi--header-content"
              label={<FormattedMessage id="monitoringSoftware" />}
            ></Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={20}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              style={{ marginLeft: "2vh" }}
              className="roi--label-section"
              label={<FormattedMessage id="nbPatientIncl" />}
            >
              <hr className="roi--hr" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              colon={false}
              className="roi--label-section"
              name="nbPatientIncl"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginTop: "2vh" }}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4}>
                <span className="roi--header-content">
                  <FormattedMessage id="tier" />
                </span>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <span className="roi--header-content">
                  <FormattedMessage id="lowerLimit" />
                </span>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <span className="roi--header-content">
                  <FormattedMessage id="tiers" />
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <span className="roi--header-content">
              <FormattedMessage id="licenseFee" />
            </span>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <span className="roi--header-content">
              <FormattedMessage id="perPatient" />
            </span>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <span className="roi--header-content">
              <FormattedMessage id="braces" />
            </span>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    <FormattedMessage id="tier" />1
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">1</span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    0<FormattedMessage id="to" />
                    30
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier1LicenseFee"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier1PerPatient"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="11.9"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier1Braces"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="17.9"
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4} style={{ textAlign: "center" }}></Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">21</span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    31
                    <FormattedMessage id="to" />
                    50
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="licenseFee"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="perPatient"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="11.9"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="bracesInput"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="17.9"
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    <FormattedMessage id="tier" />2
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">51</span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    51
                    <FormattedMessage id="to" />
                    100
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier2LicenseFee"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier2PerPatient"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="11.9"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier2Braces"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="17.9"
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    <FormattedMessage id="tier" />3
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">101</span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    101
                    <FormattedMessage id="to" />
                    200
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier3LicenseFee"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier3PerPatient"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="10.7"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier3Braces"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="16.1"
                className="roi--input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    <FormattedMessage id="tier" />4
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">201</span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    201
                    <FormattedMessage id="to" />
                    400
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier4LicenseFee"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier4PerPatient"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="9.5"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier4Braces"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                className="roi--input"
                defaultValue="14.3"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Row gutter={24}>
              <Col span={4}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">
                    <FormattedMessage id="tier" />5
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">401</span>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Form.Item
                  rules={[{ required: true, message: "", whitespace: true }]}
                >
                  <span className="roi--label-section">400+</span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier5LicenseFee"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="0"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier5PerPatient"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                defaultValue="9.5"
                className="roi--input"
              />
            </Form.Item>
          </Col>
          <Col span={4} style={{ textAlign: "center" }}>
            <Form.Item
              rules={[{ required: true, message: "", whitespace: true }]}
              name="tier5Braces"
            >
              <Input
                rules={[{ required: true, message: "", whitespace: true }]}
                type="number"
                prefix={symbol}
                className="roi--input"
                defaultValue="14.3"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );

  const claimMonitoring = (
    <Form name="vision" form={formMonitoring}>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--header-content"
            label={<FormattedMessage id="monitoringAligners" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="reductionInNumberOfCheckUp" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="adultsOrAverage" />}
          >
            {" "}
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInNumberOfCheckUpAverageLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInNumberOfCheckUpAverageHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>

      {/*----------------------------------------------------- */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="impliedReduction" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="adultsOrAverage" />}
          >
            {" "}
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="impliedReductionAverageLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="impliedReductionAverageHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>

      {/*----------------------------------------------------- */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="reductionInNumberOfEmergency" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="adultsOrAverage" />}
          >
            {" "}
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInNumberOfEmergencyAverageLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInNumberOfEmergencyAverageHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>

      {/*Initial appointments */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="initialAppointments" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="initialAppointmentsNumber" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="initialAppointments"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="initialAppointmentsDoctor"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="initialAppointmentsDentalAssistant"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="initialAppointmentsTreatment"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="initialAppointmentsFrontDesk"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      {/*Chekup adjustment */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="checkUpAdjustment" />
                <FormattedMessage id="staff" />
              </>
            }
          ></Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />{" "}
                <FormattedMessage id="dentalAssistant" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStaffdentalAssistantLow"
          >
            <Input
              type="number"
              className="roi--input"
              suffix="%"
              rules={[{ required: true, message: "", whitespace: true }]}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStaffdentalAssistantHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />
                <FormattedMessage id="treatmentCoordinator" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStafftreatmentCoordinatorLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStafftreatmentCoordinatorHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />
                <FormattedMessage id="frontDesk" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStafffrontDeskLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStafffrontDeskhigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="checkUpAdjustment" />
                <FormattedMessage
                  style={{ textTransform: "uppercase" }}
                  id="Doctor"
                />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStaffDoctorLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="checkUpAdjustmentStaffDoctorHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      {/* refinements appointments */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="refinementAppointments" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="refinementAppointmentsNumber" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="refinementAppointmentsNumber"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="refinementsAppointmentsDoctor"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="refinementsAppointmentsDentalAssistant"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="refinementsAppointmentsTreatment"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="refinementsAppointmentsFrontDesk"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      {/*Reduction in prepare */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="reductionInPrepare" />
                <FormattedMessage id="staff" />
              </>
            }
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />{" "}
                <FormattedMessage id="dentalAssistant" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInPreparedentalAssistantLow"
          >
            <Input
              type="number"
              className="roi--input"
              suffix="%"
              rules={[{ required: true, message: "", whitespace: true }]}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInPreparedentalAssistantHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />
                <FormattedMessage id="treatmentCoordinator" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInPreparetreatmentCoordinatorLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInPreparetreatmentCoordinatorHigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />
                <FormattedMessage id="frontDesk" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInPreparefrontDeskLow"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="reductionInPreparefrontDeskhigh"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      {/*final appointments */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="finalAppointments" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="initialAppointmentsNumber" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="finalAppointments"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="finalAppointmentsDoctor"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="finalAppointmentsDentalAssistant"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="finalAppointmentsTreatment"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="finalAppointmentsFrontDesk"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      {/*manage dm notifications */}
      {/* <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="manageDM" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsDoctorLow"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsDoctorHigh"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsDentalAssistantLow"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsDentalAssistantHigh"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsTreatmentLow"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsTreatmentHigh"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsFrontDeskLow"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="manageDMsFrontDeskHigh"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row> */}
      {/* Implied Reduction in Practice's time spent per patient over the treatment 
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="impliedReductionInPractice" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="adultsOrAverage" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="impliedReductionInPracticeAdultsLow"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="impliedReductionInPracticeAdultsHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="teens" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="impliedReductionInPracticeTeensLow"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="impliedReductionInPracticeTeensHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" suffix="%" />
          </Form.Item>
        </Col>
      </Row> */}
      {/** tratment duration adult*/}
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentDurationAdults" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="treatmentDurationAdults"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" suffix="mths" />
          </Form.Item>
        </Col>
      </Row>
      {/** treatment duration teen*/}
      {/* <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentDurationTeen" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="treatmentDurationTeen"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" suffix="mths" />
          </Form.Item>
        </Col>
      </Row>
*/}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="minimumIncrease" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="increaseLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="increaseHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  const claimBraces = (
    <Form name="vision" form={formclaimBraces}>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--header-content"
            label={<FormattedMessage id="monitoringBraces" />}
          ></Form.Item>
        </Col>
      </Row>
      {/** reduction in number of check up */}

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="reductionInNumberCheckUp" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="adultsOrAverage" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="monitoringBracesadultsOrAverageLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="monitoringBracesadultsOrAverageHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="teens" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="monitoringBracesteensLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="monitoringBracesteensHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/** reduction in number of emergency check up */}

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="reductionInNumberOfEmergency" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="adultsOrAverage" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="monitoringreductionInNumberOfEmergencyadultsOrAverageLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="monitoringreductionInNumberOfEmergencyadultsOrAverageHigh"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/*Initial appointments */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="initialAppointments" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="initialAppointmentsNumber" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="initialAppointments"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="initialAppointmentsDoctor"
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="initialAppointmentsDentalAssistant"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            suffix="min"
            name="initialAppointmentsTreatment"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="initialAppointmentsFront"
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/** Reduction in check-up  appointment's time */}

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="reductionInCheckUp" />
                <FormattedMessage id="staff" />
              </>
            }
          ></Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="treatmentCoordinator" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="reductionInCheckUpTreatmentLow"
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="reductionInCheckUpTreatmentHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="frontDesk" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="reductionInCheckUpFrontLow"
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="reductionInCheckUpFrontHigh"
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="dentalAssistant" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="reductionInCheckUpDentalLow"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="reductionInCheckUpDentalHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="reductionInCheckUp" />
                <FormattedMessage
                  style={{ textTransform: "uppercase" }}
                  id="Doctor"
                />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="reductionInCheckUpDocLow"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="reductionInCheckUpDocHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/*Reduction in prepare */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="reductionInPrepare" />
                <FormattedMessage id="staff" />
              </>
            }
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />
                <FormattedMessage id="frontDesk" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="ofWFrontLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="ofWFrontHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />
                <FormattedMessage id="treatmentCoordinator" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="ofWTreatmentLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="ofWTreatmentHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="ofW" />{" "}
                <FormattedMessage id="dentalAssistant" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="ofWdentalAssistantLow"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="ofWdentalAssistantHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/*manage dm notifications */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="manageDM" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="manageDMDoctorLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="manageDMDoctorHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="manageDMFrontLow"
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="manageDMFrontHigh"
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="manageTreatmentLow"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="manageTreatmentHigh"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="manageDentalLow"
            colon={false}
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="manageDentalHigh"
            className="roi--label-section"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/*Removal & retainer appointments */}
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="removalRetainer" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="initialAppointmentsNumber" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="removalRetainer"
          >
            <Input type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="doctor" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="removalRetainerDoctor"
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="removalRetainerFront"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentCoordinator" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="removalRetainerTreatment"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="dentalAssistant" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="removalRetainerDental"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>

      {/* Implied Reduction in Practice's time spent per patient over the treatment  */}
      {/** treatment duration teen*/}

      {/* <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentDurationTeen" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="treatmentDurationTeen"
            className="roi--label-section"
          >
            <Input suffix="mth" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row> */}

      {/** tratment duration adult*/}
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="treatmentDurationAdults" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            name="treatmentDurationAdults"
            className="roi--label-section"
          >
            <Input suffix="mth" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  const managingDmNotification = (
    <Form form={formDmNotifications}>
      {/*"managing DM Notifications"*/}

      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--header-content"
            label={<FormattedMessage id="managingDmNotif" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="doctor" />
                <FormattedMessage id="timeSpentPerScan" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="doctorTimeSpent"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="doctor" />
                <FormattedMessage id="percentageScan" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="doctorPercentageScan"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="dentalAssistant" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="dentalAssistant"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="treatmentCoordinator" />
                <FormattedMessage id="timeSpentPerScan" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="treatmentCoordinatorTimeSpent"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="treatmentCoordinator" />
                <FormattedMessage id="percentageScan" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="treatmentCoordinatorPercentageScan"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="%" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={<FormattedMessage id="frontDesk" />}
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--label-section"
            name="frontDesk"
          >
            <Input type="number" className="roi--input" suffix="min" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
  const inputPractice = (
    <Form form={formInput}>
      <Row gutter={24}>
        <Col span={16}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            colon={false}
            className="roi--header-content"
            label={<FormattedMessage id="inputPracticeDefault" />}
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={22}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="aligners" />
              </>
            }
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="drCheckupAppt" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="alignersdrTime"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="staffCheckUpApt" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="alignersstaffCheckup"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="staffPrepareApt" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="alignersstaffPrepare"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={22}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "2vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="braces" />
              </>
            }
          ></Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="drCheckupAppt" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="bracesdrTime"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="staffCheckUpApt" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="bracesstaffCheckup"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={20}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            style={{ marginLeft: "6vh" }}
            colon={false}
            className="roi--label-section"
            label={
              <>
                <FormattedMessage id="staffPrepareApt" />
              </>
            }
          >
            <hr className="roi--hr" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            rules={[{ required: true, message: "", whitespace: true }]}
            name="bracesstaffPrepare"
            colon={false}
            className="roi--label-section"
          >
            <Input suffix="min" type="number" className="roi--input" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
  const claim = (
    <>
      <Form form={formClaim}>
        {claimMonitoring}
        {claimBraces}
        {managingDmNotification}
        {inputPractice}
      </Form>
    </>
  );

  const onChangeCurrency = (x) => {
    toUpdateSelectedCurrency(listInputs.filter((e) => e.name == x)[0]);
  };
  return (
    <>
      <Header />

      <div style={{ textAlign: "center", marginTop: "10vh" }}>
        <Typography.Title level={2} className="roi--title-admin">
          <FormattedMessage id="manageInputsCalculation" />
          <div style={{ marginTop: "1vh" }}>
            <span className="roi--label-section"> </span>
          </div>
        </Typography.Title>
      </div>
      <Row
        className="roi--background-section"
        style={{ marginRight: "1vh", minHeight: "6vh" }}
      >
        <Col
          xl={4}
          md={6}
          className="roi--header-content"
          style={{ marginTop: "2vh", marginLeft: "2vh" }}
        >
          <span style={{ marginLeft: "1vh" }}>
            <FormattedMessage id="name" />
          </span>
        </Col>
        <Col
          style={{ marginTop: "1vh" }}
          xl={8}
          md={12}
          className="roi--header-content"
        >
          <Input
            onChange={(e) => setName(e.target.value)}
            value={name}
            style={{ width: "60%" }}
          />
        </Col>
      </Row>
      {loading ? (
        <ScreenLoader />
      ) : (
        <>
          <Row style={{ marginRight: "1vh" }}>
            <Col span="24">
              <CollapseComponent
                style={{ marginBottom: "2vh", marginTop: "1vh" }}
                className="roi--collapse-green"
                className2="roi--background-currency"
                headerText={
                  <Row>
                    <Col xl={4} md={6}>
                      <FormattedMessage id="currency" />
                    </Col>
                    <Col xl={20} md={18}>
                      <Col span={6} style={{ marginTop: "1vh" }}>
                        <Form form={formSelect}>
                          <Form.Item name="currency">
                            <Select
                              showSearch
                              style={{ width: "100%" }}
                              onClick={(e) => e.stopPropagation()}
                              className={"roi--select-currency"}
                              onChange={(e) => {
                                onChangeCurrency(e);
                              }}
                            >
                              <Option
                                className="roi--option-currency"
                                value="usd"
                              >
                                <FormattedMessage id="usd" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="aud"
                              >
                                <FormattedMessage id="aud" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="euro"
                              >
                                <FormattedMessage id="euro" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="gbp"
                              >
                                <FormattedMessage id="gbp" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="hkd"
                              >
                                <FormattedMessage id="hkd" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="nzd"
                              >
                                <FormattedMessage id="nzd" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="sgd"
                              >
                                <FormattedMessage id="sgd" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="thb"
                              >
                                <FormattedMessage id="thb" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="twd"
                              >
                                <FormattedMessage id="twd" />
                              </Option>
                              <Option
                                className="roi--option-currency"
                                value="yen"
                              >
                                <FormattedMessage id="yen" />
                              </Option>
                            </Select>
                          </Form.Item>
                        </Form>
                      </Col>
                    </Col>
                  </Row>
                }
                classNameHeader="roi--collapse-header-green"
                content={pricing}
              ></CollapseComponent>
            </Col>
          </Row>
          <Row style={{ marginRight: "1vh" }}>
            <Col span="24">
              <CollapseComponent
                style={{ marginBottom: "2vh" }}
                headerText={<FormattedMessage id="claims" />}
                classNameHeader="roi--collapse-header-green"
                content={claim}
              ></CollapseComponent>{" "}
            </Col>
          </Row>
          <div
            style={{
              marginTop: "10vh",
              paddingBottom: "5vh",
              textAlign: "center",
            }}
          >
            <Button
              onClick={() => validateForms()}
              className="roi--button-primary"
            >
              <FormattedMessage id="validate" />
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default Inputs;
